import React from 'react';
import { useContext, useEffect } from "react";
import leloContext from "../../context/leloreg/leloContext";
import { useParams } from "react-router-dom";

const SessionExpired = () => {
  const { getLeloSession, leloSession } = useContext(leloContext);
  const { permalink, _id, LeloRegistrationProfile } = useParams();
  const enrollmentStart = leloSession?.data?.length > 0 ? leloSession.data[0].enrollmentStart : null;
  const enrollmentEnd = leloSession?.data?.length > 0 ? leloSession.data[0].enrollmentEnd : null;
  const sessionStatus = leloSession?.data?.length > 0 ? leloSession.data[0].status : null;

  useEffect(() => {
    getLeloSession(permalink);
  }, [permalink]);

  const currentDate = new Date();
  const startDate = enrollmentStart ? new Date(enrollmentStart) : null;
  const endDate = enrollmentEnd ? new Date(enrollmentEnd) : null;

  // Helper function to format date as mm-dd-yyyy
  const formatDate = (date) => {
    if (!date) return null;
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  };

  let message = "";
  if (startDate && currentDate < startDate) {
    message = (
      <span>
        <h2 className="session-title">Enrollment Opening Soon</h2>
        Registration for the <strong className="bold-permalink">{permalink}</strong> session has not yet opened. Thank you for your interest.
        <br />
        <span>Please check back on <strong>{formatDate(startDate)}</strong> to begin your application.</span>
      </span>
    );
  } else if (
    (endDate && currentDate >= new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59)) ||
    sessionStatus === "Inactive"
  ) {
    message = (
      <span>
        <h1 className="session-title">Session Expired</h1>
        Registration for the <strong className="bold-permalink">{permalink}</strong> session has now closed. Thank you for your interest.
      </span>
    );
  }

  return (
    <div className="session-expired-container">
      <p className="session-message">{message}</p>
    </div>
  );
};

export default SessionExpired;